import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, inr } from "../lib/api";

export default function MockPay() {
  const { gid } = useParams();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [method, setMethod] = useState("upi");
  const [busy, setBusy] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { api.get(`/mock-gateway/${gid}`).then((r) => setInfo(r.data)).catch((e) => setErr(errMsg(e))); }, [gid]);

  const go = async (outcome) => {
    setBusy(outcome);
    try {
      const { data } = await api.post(`/mock-gateway/${gid}/complete`, { outcome, method });
      if (outcome === "fail") toast.error("Payment failed. You can try again.");
      nav(data.redirect, { replace: true });
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(null);
    }
  };

  if (err) return <div className="grid min-h-screen place-items-center p-8 text-center" data-testid="mock-pay-error"><p>{err}</p></div>;
  if (!info) return <div className="grid min-h-screen place-items-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  const done = info.status !== "created" || info.order_status !== "pending_payment";

  return (
    <div className="min-h-screen bg-[#EEF2F7] px-4 py-10" data-testid="mock-pay-page">
      <div className="mx-auto max-w-sm overflow-hidden rounded-3xl bg-white shadow-xl">
        <div className="bg-[#0B3D91] px-6 py-5 text-white">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-blue-200">Mock gateway · test mode</p>
          <p className="mt-2 text-sm">{info.merchant}</p>
          <p className="font-display text-4xl font-bold" data-testid="mock-pay-amount">{inr(info.amount_paise)}</p>
          <p className="text-xs text-blue-200">Order #{info.order_no}</p>
        </div>
        <div className="space-y-3 p-6">
          <div className="grid grid-cols-3 gap-2 text-xs font-semibold">
            {["upi", "card", "netbanking"].map((m) => (
              <button key={m} data-testid={`mock-method-${m}`} onClick={() => setMethod(m)} className={`rounded-xl border-2 py-2.5 uppercase ${method === m ? "border-[#0B3D91] text-[#0B3D91]" : "border-slate-200 text-slate-500"}`}>{m}</button>
            ))}
          </div>
          {done ? (
            <p className="rounded-xl bg-slate-100 p-3 text-sm" data-testid="mock-pay-done">This checkout is {info.status}.</p>
          ) : (
            <>
              <button data-testid="mock-pay-success-button" disabled={!!busy} onClick={() => go("success")} className="flex w-full items-center justify-center gap-2 rounded-xl bg-emerald-600 py-4 font-semibold text-white disabled:opacity-60">
                {busy === "success" ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />} Pay successfully
              </button>
              <button data-testid="mock-pay-fail-button" disabled={!!busy} onClick={() => go("fail")} className="flex w-full items-center justify-center gap-2 rounded-xl border-2 border-red-200 py-3.5 font-semibold text-red-600 disabled:opacity-60">
                <XCircle className="h-4 w-4" /> Fail
              </button>
            </>
          )}
          <button data-testid="mock-pay-back" onClick={() => nav(`/order/${info.order_id}?t=${info.guest_token}`)} className="w-full py-2 text-xs text-slate-500 underline">Back to order</button>
          <p className="text-center text-[11px] text-slate-400">The gateway confirms payment to MyBigPlate with a signed server-to-server webhook.</p>
        </div>
      </div>
    </div>
  );
}
